<template lang="html">
    <div id="d-page-template-1">

        <section class="short-info-section-s1">
            <div class="box-top">
                <div class="col-12 col-title">
                <h2 class="txt-breadcrumb">
                    <span>Mi perfil</span>
                    Histórico de puestos
                </h2>
                </div>
            </div>
        </section>
        <section class="requests-section">    
            <div class="box-results" v-if="!loading">
                <b-card no-body>
                        <b-card-text>
                        <div class="no-gutters post-template-s4" v-for="(v, vInx) in rows" :key="'vInx-'+vInx">
                            
        
                            <div class="col-sm col-time">
                              <h6>Agencia anterior</h6>
                              <h5>{{v.previous_agency}}</h5>
                            </div>
        
                            <div class="col-sm col-time">
                              <h6>Puesto anterior</h6>
                              <h5>{{v.previous_position}}</h5>
                            </div>
        
                            <div class="col-sm col-time">
                              <h6>Puesto nuevo</h6>
                              <h5>{{v.new_position}}</h5>
                            </div>
                            <div class="col-sm col-time">
                              <h6>Fecha de cambio</h6>
                              <h5>{{v.change_date}}</h5>
                            </div>
                            <div class="col-sm col-time">
                              <h6>Agencia actual</h6>
                              <h5>{{v.current_agency}}</h5>
                            </div>
                        </div>
                        </b-card-text>
                    
                </b-card>
            </div>
            <div class="box-results" v-else style="padding-top: 150px;text-align: center;">
                <div class="fa-5x"><i class="fas fa-spinner fa-pulse"></i></div><br>
                
            </div>
        </section>
  
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        rows:{},
        loading:false,
        

      }
    },
  
    methods: {
        getRows(){
          this.loading = true;
          axios.get(tools.url("/api/user/contracts")).then((response)=>{
              this.rows = response.data;
              this.loading = false;
          }).catch(()=>{
              this.modal.block = false;
              this.loading = false;
          });
        },
  
    },
  
    beforeMount(){
     
    },
  
    mounted() {
        this.getRows();
    },
  }
  </script>
  